module.exports = __webpack_public_path__ + "static/media/StandingTall.bd29da09.mp3";